import { XIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { ArrowUp } from 'src/shared/components/icons/arrow-up'
import { Button } from 'src/shared/components/ui/buttons/button'

import { UPLOAD_LEADS_EXIT_PATH } from '../constants/ul-config'
import { useUploadLeadsContext } from '../context/upload-leads-context'

const ULHeader = ({ showBackButton }: { showBackButton?: boolean }) => {
  const { handleBack } = useUploadLeadsContext()
  const navigate = useNavigate()

  const handleCloseClick = () => {
    navigate(UPLOAD_LEADS_EXIT_PATH)
  }

  return (
    <div className="absolute inset-x-0 top-0 z-50 flex flex-row items-center justify-between px-5 py-6">
      {showBackButton ? (
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBack}
          className="size-[50px] bg-accent hover:bg-primary hover:text-white"
        >
          <ArrowUp size={15} className="-rotate-90" />
        </Button>
      ) : (
        <div className="size-[50px]" />
      )}
      <p className="text-base font-semibold">{'Upload leads'}</p>
      <Button
        variant="ghost"
        size="icon"
        onClick={handleCloseClick}
        className="size-[50px] bg-accent hover:bg-primary hover:text-white"
      >
        <XIcon className="size-7" strokeWidth={2} />
      </Button>
    </div>
  )
}

export default ULHeader
